import { render, staticRenderFns } from "./proposal-30-pricing-options.vue?vue&type=template&id=549d0c0f"
import script from "./proposal-30-pricing-options.vue?vue&type=script&lang=js"
export * from "./proposal-30-pricing-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports